import { disposeLoggers } from "../../../common/telemetry/TelemetryManager";
export const disposeTelemetryLoggers = () => {
  disposeLoggers();
};